export default class EnvironmentVariables {
  static vars: Record<string, string | undefined> = {
    // GENERAL
    ENV: process.env.NODE_ENV,
    INCLUDE_WEB_ROOT: process.env.REACT_APP_INCLUDE_WEB_ROOT,
    PROFILE_IMAGE_BASE_URL: process.env.REACT_APP_PROFILE_IMAGE_BASE_URL,
    // APIS
    ARRANGER_API: process.env.REACT_APP_ARRANGER_API_URL,
    ARRANGER_PROJECT_ID: process.env.REACT_APP_ARRANGER_PROJECT_ID,
    USERS_API: process.env.REACT_APP_USERS_API_URL,
    // CAVATICA
    CAVATICA_USER_BASE_URL: process.env.REACT_APP_CAVATICA_USER_BASE_URL,
    CAVATICA_GUID_ACCESS_URL: process.env.REACT_APP_CAVATICA_GUID_ACCESS_URL,
    CAVATICA_DSC_DEMOGRAPHIC_ACCESS_URL: process.env.REACT_APP_CAVATICA_DSC_DEMOGRAPHIC_ACCESS_URL,
    CAVATICA_DSC_IHQ_ACCESS_URL: process.env.REACT_APP_CAVATICA_DSC_IHQ_ACCESS_URL,
    CAVATICA_DSC_DICTIONARY_ACCESS_URL: process.env.REACT_APP_CAVATICA_DSC_DICTIONARY_ACCESS_URL,
    CAVATICA_AECOM_DS_UH_CLINICAL_MRI_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_AECOM_DS_UH_CLINICAL_MRI_ACCESS_URL,
    CAVATICA_DS_SLEEP_UH_CLINICAL_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_SLEEP_UH_CLINICAL_DATA_ACCESS_URL,
    CAVATICA_DS_SLEEP_UH_CLINICAL_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_SLEEP_UH_CLINICAL_DICTIONARY_ACCESS_URL,
    CAVATICA_DS_SLEEP_UH_SLEEP_CSHQ_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_SLEEP_UH_SLEEP_CSHQ_DATA_ACCESS_URL,
    CAVATICA_DS_SLEEP_UH_SLEEP_CSHQ_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_SLEEP_UH_SLEEP_CSHQ_DICTIONARY_ACCESS_URL,
    CAVATICA_DS_SLEEP_UH_SLEEP_ESS_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_SLEEP_UH_SLEEP_ESS_DATA_ACCESS_URL,
    CAVATICA_DS_SLEEP_UH_SLEEP_ESS_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_SLEEP_UH_SLEEP_ESS_DICTIONARY_ACCESS_URL,
    CAVATICA_DS_SLEEP_UH_SLEEP_INTAKE_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_SLEEP_UH_SLEEP_INTAKE_DATA_ACCESS_URL,
    CAVATICA_DS_SLEEP_UH_SLEEP_INTAKE_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_SLEEP_UH_SLEEP_INTAKE_DICTIONARY_ACCESS_URL,
    CAVATICA_DS_SLEEP_UH_SLEEP_SDS_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_SLEEP_UH_SLEEP_SDS_DATA_ACCESS_URL,
    CAVATICA_DS_SLEEP_UH_SLEEP_SDS_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_SLEEP_UH_SLEEP_SDS_DICTIONARY_ACCESS_URL,
    CAVATICA_X01_HAKONARSON_UH_CLINICAL_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_X01_HAKONARSON_UH_CLINICAL_ACCESS_URL,
    CAVATICA_X01_DESMITH_CLINICAL_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_X01_DESMITH_CLINICAL_DATA_ACCESS_URL,
    CAVATICA_X01_DESMITH_CLINICAL_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_X01_DESMITH_CLINICAL_DICTIONARY_ACCESS_URL,
    CAVATICA_DS_DETERMINED_SDI_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_SDI_DICTIONARY_ACCESS_URL,
    CAVATICA_DS_DETERMINED_SDI_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_SDI_DATA_ACCESS_URL,
    CAVATICA_DS_DETERMINED_CDM_CONDITION_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_CDM_CONDITION_ACCESS_URL,
    CAVATICA_DS_DETERMINED_CDM_DEATH_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_CDM_DEATH_ACCESS_URL,
    CAVATICA_DS_DETERMINED_CDM_DEMOGRAPHIC_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_CDM_DEMOGRAPHIC_ACCESS_URL,
    CAVATICA_DS_DETERMINED_CDM_DIAGNOSIS_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_CDM_DIAGNOSIS_ACCESS_URL,
    CAVATICA_DS_DETERMINED_CDM_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_CDM_DICTIONARY_ACCESS_URL,
    CAVATICA_DS_DETERMINED_CDM_ENCOUNTER_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_CDM_ENCOUNTER_ACCESS_URL,
    CAVATICA_DS_DETERMINED_CDM_IMMUNIZATION_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_CDM_IMMUNIZATION_ACCESS_URL,
    CAVATICA_DS_DETERMINED_CDM_LAB_RESULT_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_CDM_LAB_RESULT_ACCESS_URL,
    CAVATICA_DS_DETERMINED_CDM_MED_ADMIN_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_CDM_MED_ADMIN_ACCESS_URL,
    CAVATICA_DS_DETERMINED_CDM_PRESCRIBING_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_CDM_PRESCRIBING_ACCESS_URL,
    CAVATICA_DS_DETERMINED_CDM_PRO_CM_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_CDM_PRO_CM_ACCESS_URL,
    CAVATICA_DS_DETERMINED_CDM_PROCEDURES_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_CDM_PROCEDURES_ACCESS_URL,
    CAVATICA_DS_DETERMINED_CDM_VITAL_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_CDM_VITAL_ACCESS_URL,
    CAVATICA_DS_DETERMINED_DSC_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_DSC_DATA_ACCESS_URL,
    CAVATICA_DS_DETERMINED_DSC_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_DSC_DICTIONARY_ACCESS_URL,
    CAVATICA_DS_DETERMINED_DSC_MAPPING_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_DS_DETERMINED_DSC_MAPPING_ACCESS_URL,
    CAVATICA_BRAIN_POWER_AGE_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_AGE_DATA_ACCESS_URL,
    CAVATICA_BRAIN_POWER_AGE_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_AGE_DICTIONARY_ACCESS_URL,
    CAVATICA_BRAIN_POWER_ANTHROPOMETRICS_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_ANTHROPOMETRICS_DICTIONARY_ACCESS_URL,
    CAVATICA_BRAIN_POWER_ANTHROPOMETRICS_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_ANTHROPOMETRICS_DATA_ACCESS_URL,
    CAVATICA_BRAIN_POWER_COGNITIVE_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_COGNITIVE_DATA_ACCESS_URL,
    CAVATICA_BRAIN_POWER_COGNITIVE_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_COGNITIVE_DICTIONARY_ACCESS_URL,
    CAVATICA_BRAIN_POWER_IMAGING_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_IMAGING_DATA_ACCESS_URL,
    CAVATICA_BRAIN_POWER_IMAGING_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_IMAGING_DICTIONARY_ACCESS_URL,
    CAVATICA_BRAIN_POWER_PA_DAY_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_PA_DAY_DATA_ACCESS_URL,
    CAVATICA_BRAIN_POWER_PA_DAY_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_PA_DAY_DICTIONARY_ACCESS_URL,
    CAVATICA_BRAIN_POWER_PA_PERSON_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_PA_PERSON_DATA_ACCESS_URL,
    CAVATICA_BRAIN_POWER_PA_PERSON_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_PA_PERSON_DICTIONARY_ACCESS_URL,
    CAVATICA_BRAIN_POWER_RANDOMIZATION_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_RANDOMIZATION_DATA_ACCESS_URL,
    CAVATICA_BRAIN_POWER_RANDOMIZATION_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_RANDOMIZATION_DICTIONARY_ACCESS_URL,
    CAVATICA_BRAIN_POWER_DEMOGRAPHICS_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_DEMOGRAPHICS_DATA_ACCESS_URL,
    CAVATICA_BRAIN_POWER_DEMOGRAPHICS_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_DEMOGRAPHICS_DICTIONARY_ACCESS_URL,
    CAVATICA_BRAIN_POWER_HEALTH_DATA_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_HEALTH_DATA_ACCESS_URL,
    CAVATICA_BRAIN_POWER_HEALTH_DICTIONARY_ACCESS_URL:
      process.env.REACT_APP_CAVATICA_BRAIN_POWER_HEALTH_DICTIONARY_ACCESS_URL,
    // FENCES
    KEY_MANAGER_API_URL: process.env.REACT_APP_KEY_MANAGER_API_URL,
    FENCE_API_URL: process.env.REACT_APP_FENCE_API_URL,
    CAVATICA_FENCE_PROXY: process.env.REACT_APP_CAVATICA_FENCE_PROXY,
    // KEYCLOAK
    KC_AUTH_SERVER_URL: process.env.REACT_APP_KC_AUTH_SERVER_URL,
    KC_CLIENT_ID: process.env.REACT_APP_KC_CLIENT_ID,
    KC_REALM: process.env.REACT_APP_KC_REALM,
    // USERSNAP
    USER_SNAP_API_KEY: process.env.REACT_APP_USER_SNAP_API_KEY,
    //REPORT
    REPORTS_API_URL: process.env.REACT_APP_REPORTS_API_URL,
    // GA
    MEASUREMENT_ID: process.env.REACT_APP_MEASUREMENT_ID,
    WEB_ROOT: process.env.REACT_APP_WEB_ROOT,
    // Sentry
    SENTRY_API: process.env.REACT_APP_SENTRY_API,
  };

  static configFor(key: string): string {
    return EnvironmentVariables.vars[key] || '';
  }
}

export const getEnvVarByKey = <T>(key: string, defaultValue?: T): T =>
  (process.env[`REACT_APP_${key}`] as any) || defaultValue;

export const getFTEnvVarByKey = <T>(key: string, defaultValue?: T): T =>
  (process.env[`REACT_APP_FT_${key}`] as any) || defaultValue;
